import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import AppButton from '../../../components/Button/AppButton/AppButton';
import ConnectionTrackButton from '../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import {IconWarranty} from '../../../components/Icons';
import {ContentWrapper, MaxWidthContainer} from '../../../components/Layout';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import * as tncTypes from '../../../consts/tnc/tncTypes';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import appRouterService from '../../../services/route/appRouterService';
import tncService from '../../../services/tncService';
import {hideLoader, setNotificationInfo, showLoader} from '../../../state/ducks/global';
import {makeSelectAcceptedTncByType, makeSelectTncByType} from '../../../state/selectors/consumer';
import {dispatch} from '../../../state/store';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import TermsOfUseDescription from '../TermsOfUseDescription/TermsOfUseDescription';

const mapStateToProps = createStructuredSelector({
    termsOfUse: makeSelectTncByType(tncTypes.TERMS_OF_USE),
    acceptedTermsOfUse: makeSelectAcceptedTncByType(tncTypes.TERMS_OF_USE),
});

const TermsOfUsePage = (props) => {
    const {termsOfUse, acceptedTermsOfUse} = props;
    const localizedStrings = getLocalizedStrings();

    useEffect(() => {
        tncService.getAggregatedSettings();
    }, []);

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_TERMS_OF_USE_PAGE_TITLE]);

    if (!termsOfUse) return null;

    const {description, legals, updateDescription} = termsOfUse;

    if (!legals) {
        appRouterService.forwardToTNCDataCollectionPage();
        return null;
    }

    const onAcceptButtonClick = async () => {
        dispatch(showLoader());

        analyticsService.pushTermsOfUseData(true);
        await tncService.setTnc(legals);

        dispatch(hideLoader());
    };

    const onDeclineButtonClick = () => {
        analyticsService.pushTermsOfUseData(false);

        dispatch(
            setNotificationInfo({
                textKey: localizationKeys.TERMS_SUMMARY_ERROR_NOTIFICATION_TEXT,
                testId: elementsTesIds.TNC_TOU_NOTIFICATION,
            })
        );
    };

    const isUpdatedTnc = acceptedTermsOfUse != null;
    const summaryTitleText = isUpdatedTnc
        ? localizationKeys.TERMS_SUMMARY_UPDATE_TITLE_TEXT
        : localizationKeys.TERMS_SUMMARY_TITLE_TEXT;
    const descriptionText = isUpdatedTnc ? updateDescription : description;

    return (
        <ContentWrapper testId={elementsTesIds.TERMS_OF_USE_PAGE}>
            <MaxWidthContainer>
                <IconWarranty className='mt-12 h-[64px] w-[64px] p-[7px] lg:mt-14' />
                <h1 className='mt-3 lg:mt-4'>{localizedStrings[summaryTitleText]}</h1>
                <TermsOfUseDescription innerHtml={descriptionText} />
                <div className='my-10 flex w-full flex-col gap-3 md:flex-row md:justify-center md:gap-8'>
                    <AppButton
                        secondary
                        light
                        onClick={onDeclineButtonClick}
                        testId={elementsTesIds.TNC_TOU_BTN_DECLINE}
                        className='order-1 m-0 md:order-none'
                    >
                        {localizedStrings[localizationKeys.TERMS_SUMMARY_DECLINE_BUTTON_TEXT]}
                    </AppButton>
                    <ConnectionTrackButton
                        button={AppButton}
                        className='m-0'
                        primary
                        light
                        testId={elementsTesIds.TNC_TOU_BTN_AGREE}
                        onClick={onAcceptButtonClick}
                    >
                        {localizedStrings[localizationKeys.TERMS_SUMMARY_CONFIRM_BUTTON_TEXT]}
                    </ConnectionTrackButton>
                </div>
            </MaxWidthContainer>
        </ContentWrapper>
    );
};

export default connect(mapStateToProps)(TermsOfUsePage);
